import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {Footer} from "../../../_common/components/Footer/Footer";

export const RegistrationDataFooter = () => {
  const {count} = useSelector(
    (state) => ({count: state.registrationData.totalCount}),
    shallowEqual
  );

  return <Footer count={count}/>
};

